import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import React, {useEffect, useState} from 'react';
import DonutChart from 'react-donut-chart';
import Sidebar from '../layout/Sidebar';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Breadcrumb from './Breadcrumb';
import AxiosURL from '../../ApiService/AxiosURL';
import emitter from "./emitter"; 

const Irrigation=()=>
{
  // API urls
  const API_irrigation = "farmers/irrigations";
  let distt = "farmers/get_districts";
  // use the hook for get and set the api data
  const [irrigationData, setIrrigationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [year, setYear] = useState([]);
  const [getVillages, setVillages] = useState([]);
  const [useDistricts, setDistricts] = useState([]);
  const [getDist, setDist] = useState([]);
  // define the useEffect hook for call the function
  useEffect(()=>{
    fetchIrrigationDatas('farmers/irrigations?year=2022')
    fetchDistricts(distt);
  },[]);

  const fetchDistricts = async(url)=>{
    try{
         const response = await AxiosURL.get(url);
         setDistricts(response.data.data);
    }catch(error){
      console.log(error);
    }
  }
  // Defined the all functions get data from an api
  const fetchIrrigationDatas = async(url)=>{
     try{
      const response = await AxiosURL.get(url);
      setIrrigationData(response.data.data);
     }catch(error){
      console.log(error);
     }
  }
 
  const filteredByYear =async(data,yearVal)=>{
    if(data.target.value == 'select')
    {
      fetchIrrigationDatas(API_irrigation);
    }else{
      setIsLoading(true);
      const irrigationDataa = await AxiosURL.get(API_irrigation,{ params:{year:yearVal}})
      setIrrigationData(irrigationDataa.data.data);
      
      setIsLoading(false);
    } 
  }
  const filteredByDistrict = async (tval)=>{
    if(tval.target.value == 'select')
    {
      fetchIrrigationDatas(API_irrigation);
    }else{
      setIsLoading(true);
      var distData = tval.target.value;
      const irrigationDataa = await AxiosURL.get(API_irrigation,{params:{ district:distData}})
      setIrrigationData(irrigationDataa.data.data);
       // get Village district wise
      const resp = await AxiosURL.get('farmers/get_village/'+distData);
      setVillages(resp.data.data);
      setIsLoading(false);
    }    
  }
  const filteredByVillage = async (villVal)=>{
    if(villVal.target.value=='select')
    {
      fetchIrrigationDatas(API_irrigation);
    }
    else
    {
      const villageData=villVal.target.value;
      setIsLoading(true);
      const irrigationDataa = await AxiosURL.get(API_irrigation,{ params:{village:villageData}})
      setIrrigationData(irrigationDataa.data.data);
      
      setIsLoading(false);
    }
  }
 
  const  data2=[
        {
        label: 'Furrow',
        value: irrigationData.furrow_type_farmer,
        },
        {
        label: 'Alternate',
        value: irrigationData.alternate_furrow_type_farmer,
        },
        {
        label: 'RainFed',
        value: irrigationData.Rainfed_type_farmer,
        },
        {
        label: 'Sprinkler',
        value: irrigationData.spinkalar_type_farmer,
        },
        {
        label: 'Drip',
        value: irrigationData.drip_type_farmer,
        },    
        {
          label: 'Farmers',
          value: irrigationData.farmers,
        },    
    ];

  return (
   
  <div className='wrapper'>
    <Sidebar />
    <div className='main'>
      <Header />
      <main className='content'>
        <div className='container-fluid p-0'>

<section>
<div className="box">
  <select className="form selectTag"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByYear(value,value.target.value); setYear(value.target.value);}} >
      <option  >Select year</option>
      <option >2016</option>    
      <option >2017</option>
      <option >2018</option>
      <option >2019</option> 
      <option >2020</option> 
      <option >2021</option>  
      <option selected>2022</option>  
    </select>
    <select className="form selectTag"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByDistrict(value); setDist(value.target.value); }} >
          <option  selected>Select District</option>
                {useDistricts.map((data,i)=>{
                  return <option key={i} value={data.district}>{data.district}</option>
                })}  
      </select>
      <select className="form selectTag"  aria-label="Default select example search_select" onChange={(value)=>filteredByVillage(value)}  style={{marginLeft:5}} 
            >
        <option value={0} >Select Village</option>
                {
                getVillages.length===0
                ? "<option value={0} >select village</option>"
                :getVillages.map((data,i)=>{
                  return <option key={i} value={data.village}>{data.village}</option>
                })
                }
      </select>
  </div>
      <div className='row'>
      <div className='col col-md-12'>
        <div className='card graphCard '>
          <div className='card-body'>
            <h4>Farmer Categorization</h4>
            <h5>by type of irrigation</h5>
            <DonutChart            
              width={600}
              height={550}
              data={data2}
              innerRadius={0.1}
              selectedOffset={0.1}
              formatValues={(values) => `${(values)} Farmer's`}
              legend={true}
              options={{
                title:{              
                }
                
              }}
              colors={['#229af5','#00BB00','#FF9900','#7000FF','#323232','#000998']}
              className="pieChart"/>
          </div>
        </div>
      </div>
      {/* <div className='col col-md-4'>
        <div className='card graphCard '>
          <div className='card-body'>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Label</th>
                  <th scope="col" style={{ backgroundColor: '#FF9900', color:"#000000"}}>Value</th>
                </tr>
              </thead>
              <tbody>
              {data2.map(( listValue, index ) => {
              return (<tr key={index}>
                  <td >{listValue.label}</td>
                  <td style={{ backgroundColor: '#FF9900', color:"#000000"}}>{listValue.value}</td>
                </tr>)
              })}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
   </div>
   {/* <div className='row'>
      <div className='col col-md-12'>
        <div className='card graphCard'>
          <div className='card-body'>
            <p><strong>Total Yield By type of Irrigation</strong></p>
              <ResponsiveContainer width="100%" aspect={2.5}>
        <AreaChart
          
          data={data1}
          margin={{
            top: 10,
            right: 30,
            left: 30,
            bottom: 0,
            
          }}
        >
          <CartesianGrid horizontal="true" vertical=""/>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Area type="monotone" dataKey="yield" stroke="#40241A" fill="#229af5" unit=" kg/h" />
        </AreaChart>

      </ResponsiveContainer>
          </div>
        </div>
      </div>
     
   </div> */}
   <div className='footer'>
    <Footer />
   </div>
   </section>
        </div>
      </main>
    </div>
  </div>
  )
}
 
export default Irrigation;







   